import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { AppConfig } from '../../../app/app.config';
import { columns } from './rob-figure-outstanding-grid.config';
import { State } from '@progress/kendo-data-query';
import { KendoGridDataConfig } from '../../../_foundation/kendo/models/grid.models';
import { DailyLogPage } from '../../daily-log/daily-log/daily-log';
import { DateService } from '../../../services/date/date.service';
import { DateParserService } from '../../../services/daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../../../services/time-zone/time-zone.service';
import {
  JackingActivityRobFigureService
} from '../../../services/jacking-activity/jacking-activity-rob-figure.service';

@IonicPage()
@Component({
  selector: 'page-rob-figures-outstanding',
  templateUrl: 'rob-figure-outstanding.html',
})
export class RobFigureOutstandingPage {
  @ViewChild('robFuelFigureGrid') grid?: GridComponent;

  config = AppConfig.settings;
  gridData: GridDataResult;
  gridDataConfig: KendoGridDataConfig;
  columns = columns;
  loaded: boolean;

  state: State = {
    take: 20,
    skip: 0,
    filter: {
      logic: 'and',
      filters: []
    },
    sort: [
      {
        field: 'id',
        dir: 'desc'
      },
    ],
  };

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private dateService: DateService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService,
    private robFigureService: JackingActivityRobFigureService) {
  }

  async ionViewDidLoad() {
    await this.loadData();
  }

  private async loadData() {
    this.gridDataConfig = this.robFigureService.getOutstandingRobFigureGridDataConfig();
  }

  async openLogAtViewDate(dailyLogDateString: string) {
    const dateTime = await this.dateParserService.deserializeDate(dailyLogDateString, true, this.timeZoneService);
    // let dateTime = await this.dateService.convertLocalJSDateToDateTime(this.viewDate);
    await this.navCtrl.setRoot(DailyLogPage, {inputDate: dateTime});
  }
}



// WEBPACK FOOTER //
// ./src/pages/validation/rob-figure-outstanding/rob-figure-outstanding.ts